import React, { useEffect, useState } from "react";
import { api, poundsFromPence } from "../../lib/api";
import { SuperCard } from "../../components/SuperAdminLayout";
import { Download } from "lucide-react";

export default function SuperRevenuePage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/super/revenue").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-[#8a8a8a] py-20 text-center">Loading revenue…</div>;

  const csv = () => {
    const rows = [["Attraction", "Slug", "Tickets", "Gross (£)", "Commission (£)", "Net to attraction (£)", "Rate %", "Source"]];
    d.rows.forEach((r) => rows.push([r.name, r.slug, r.tickets_sold, (r.gross_pence / 100).toFixed(2), (r.commission_pence / 100).toFixed(2), (r.net_pence / 100).toFixed(2), (r.effective_rate * 100).toFixed(2), r.rate_source]));
    const blob = new Blob([rows.map((x) => x.map((c) => `"${c}"`).join(",")).join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob); const link = document.createElement("a");
    link.href = url; link.download = "scaretickets-revenue.csv"; link.click(); URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6" data-testid="super-revenue">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Revenue</h1>
        <button className="st-btn st-btn-ghost" onClick={csv} data-testid="revenue-export"><Download size={14} /> Export CSV</button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Total gross" value={poundsFromPence(d.totals.gross_pence)} />
        <Stat label="Platform commission" value={poundsFromPence(d.totals.commission_pence)} highlight />
        <Stat label="Avg order value" value={poundsFromPence(d.totals.avg_order_pence)} />
        <Stat label="Avg commission/order" value={poundsFromPence(d.totals.avg_commission_pence)} />
      </div>

      <SuperCard className="overflow-hidden">
        <table className="w-full text-sm" data-testid="revenue-table">
          <thead className="bg-[#141414] text-[#8a8a8a] text-xs uppercase tracking-wider">
            <tr><th className="text-left px-4 py-3">Attraction</th><th className="text-right px-4 py-3">Tickets</th><th className="text-right px-4 py-3">Gross</th><th className="text-right px-4 py-3">Commission</th><th className="text-right px-4 py-3">Net to attraction</th><th className="text-right px-4 py-3">Rate</th></tr>
          </thead>
          <tbody>
            {d.rows.map((r) => (
              <tr key={r.id} className="border-t border-[#161616]">
                <td className="px-4 py-3">{r.name}</td>
                <td className="px-4 py-3 text-right">{r.tickets_sold}</td>
                <td className="px-4 py-3 text-right">{poundsFromPence(r.gross_pence)}</td>
                <td className="px-4 py-3 text-right text-[#dc2626]">{poundsFromPence(r.commission_pence)}</td>
                <td className="px-4 py-3 text-right">{poundsFromPence(r.net_pence)}</td>
                <td className="px-4 py-3 text-right">{(r.effective_rate * 100).toFixed(1)}%{r.rate_source !== "default" && <span className="text-[10px] text-[#facc15] ml-1">{r.rate_source}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </SuperCard>
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return <SuperCard className={`p-4 ${highlight ? "border-[#3a1414]" : ""}`}><div className={`text-2xl font-bold ${highlight ? "text-[#dc2626]" : ""}`}>{value}</div><div className="text-xs text-[#8a8a8a]">{label}</div></SuperCard>;
}
